const partner = () => {
  if ($(".partner").length) {
    $('.list-article').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: $('#prev-article'),
      nextArrow: $('#next-article'),
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    const $parent = $(".partner-categories");
    $parent.find(".add-and-hide").on("click", function () {
      const $category = $(this).parents(".category");
      const isActive = $category.hasClass("active");
      if (isActive) {
        $category.removeClass('active').find(".list").slideUp();
      }
      else {
        const oldActive = $parent.find(".category.active");
        oldActive.removeClass("active").find(".list").slideUp(300);
        $category.toggleClass('active').find(".list").slideDown(300, function () {
          if (oldActive.length > 0) {
            $("html").animate({
              scrollTop: $category.offset().top - 200
            }, 300);
          }
        })
      }
    });

    //default select
    $parent.find(".category .add-and-hide").first().click();

    let categories = $('.partner-categories .category');
    for(let category of categories) {
      if ($(category).find('.item').length % 4 != 0) {
        let count = $(category).find('.item').length % 4;
        if (count != 0) {
          for (let i = 0; i < 4 - count; i++) {
            $(category).find('.item').parent().append('<div class="col-6 col-lg-3 item check-item"></div>');
          }
        }
      }
    }
  }
}

module.exports = partner
